type PrimaryTextProps = {
  text: string | null
  className?: string
}
export default function PrimaryText({ text, className }: PrimaryTextProps): JSX.Element {
  return <h3 className={`font-bold text-primary-landing sm:text-[22px] ${className ?? ''}`}>{text}</h3>
}
